// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://app.cabos.mondula.com/api';
export const SERVER_BASE_URL = API_BASE_URL.replace('/api', '');

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};

// Helper function to build server URLs (for media, uploads, etc.)
export const buildServerUrl = (path: string): string => {
  // Absolute URLs (e.g. S3 object storage) are used as-is — never prefix them.
  if (/^https?:\/\//i.test(path)) return path;
  return `${SERVER_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

/**
 * Give a media URL its own HTTP cache entry for `crossOrigin="anonymous"` loads.
 *
 * The object storage only returns `Access-Control-Allow-Origin` when the request carries an
 * `Origin` header, and it does not send `Vary: Origin`. Both variants of a response therefore
 * share one cache entry, so whichever request lands first decides what the other one gets:
 * a plain `<img>` in a grid or list caches a response with no CORS header, and a later
 * `crossOrigin="anonymous"` load of the same URL reuses that entry, fails the CORS check and
 * renders as a broken image. Splitting the CORS loads onto a distinct URL keeps them apart.
 *
 * Apply this wherever an element sets `crossOrigin` — and only there, so plain loads keep
 * sharing the unmarked entry.
 */
export const corsMediaUrl = (url: string): string => {
  if (!url) return url;
  // Relative URLs are same-origin; CORS never applies, so an extra entry would just re-download.
  if (!/^https?:\/\//i.test(url)) return url;
  // Presigned URLs sign the query string — adding to it invalidates the signature.
  if (url.includes('X-Amz-Signature')) return url;
  if (/[?&]cors=1(&|$)/.test(url)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}cors=1`;
};
